<template>
  <Layout>
    <Title :height="28" imgUrl="url('@/assets/img/bg-serv-white-title.svg')">
      <img src="@/assets/img/pdf-title-logo.svg" class="h-44 w-auto" alt="Gestor Service logo" />
    </Title>
    <About
      title="Acabe com seus problemas com arquivos"
      text="Recebeu um arquivo no formato errado? Com o PDF Service você converte qualquer arquivo Office para PDF e vice-versa, além de inserir marca d&rsquo;água, dividir, unir e editar PDFs"
      service="pdf"
    />
    <Benefits :solutionId="9" />
    <PlansComparison :solution-id="9" />
    <Solutions title="Mais soluções" />
    <Depoimentos title="Depoimentos" />
    <Faq title="Perguntas Frequentes" :questions="faqStore.questions" />
  </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';
import About from '@/components/About/About.vue';

const faqStore = useFaqStore();
</script>
